// ============================================
// Deposit Page - New Style
// ============================================

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaWallet, FaHome, FaChartBar, FaEye, FaFileAlt } from 'react-icons/fa';
import api from '../services/api';
import './Transaction.css';

const Deposit = () => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const depositAmount = parseFloat(amount);
    if (!depositAmount || depositAmount <= 0) {
      toast.error('กรุณากรอกจำนวนเงินที่ถูกต้อง');
      return;
    }

    setLoading(true);
    try {
      await api.requestDeposit(depositAmount);
      toast.success('ส่งคำขอเติมเงินสำเร็จ กรุณารอแอดมินอนุมัติ');
      navigate('/profile');
    } catch (error) {
      toast.error(error.message || 'ไม่สามารถส่งคำขอได้');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="transaction-page">
      {/* Header */}
      <div className="transaction-header">
        <button className="btn-back" onClick={() => navigate('/profile')}>
          <FaArrowLeft />
        </button>
        <h1>
          <FaWallet /> ฝากเงิน
        </h1>
      </div>

      <div className="transaction-content">
        <div className="transaction-card">
          <div className="info-box">
            <p>💡 <strong>คำแนะนำ:</strong> กรอกจำนวนเงินที่ต้องการฝาก หลังจากกดขอเติมเงินแล้ว กรุณารอแอดมินตรวจสอบและอนุมัติ</p>
            <p style={{ marginTop: '8px', fontSize: '13px' }}>⏱️ ระยะเวลาการอนุมัติ: 1-24 ชั่วโมง</p>
          </div>

          <form onSubmit={handleSubmit} className="transaction-form">
            <div className="form-group">
              <label>จำนวนเงิน (USD)</label>
              <input
                type="number"
                className="input"
                placeholder="กรอกจำนวนเงิน"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                disabled={loading}
                min="1"
                step="0.01"
              />
            </div>

            <div className="quick-amount-grid">
              <button type="button" onClick={() => setAmount('100')} disabled={loading}>
                $100
              </button>
              <button type="button" onClick={() => setAmount('500')} disabled={loading}>
                $500
              </button>
              <button type="button" onClick={() => setAmount('1000')} disabled={loading}>
                $1,000
              </button>
              <button type="button" onClick={() => setAmount('5000')} disabled={loading}>
                $5,000
              </button>
            </div>

            <button
              type="submit"
              className="btn btn-success btn-block"
              disabled={loading}
            >
              {loading ? 'กำลังส่งคำขอ...' : 'ขอเติมเงิน'}
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        <Link to="/" className="nav-item">
          <FaHome />
          <span>Home</span>
        </Link>
        <Link to="/trading" className="nav-item">
          <FaChartBar />
          <span>Trade</span>
        </Link>
        <Link to="/history" className="nav-item">
          <FaEye />
          <span>History</span>
        </Link>
        <Link to="/profile" className="nav-item">
          <FaFileAlt />
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
};

export default Deposit;
